import {
  Box,
  Container,
  Text,
  ListItem,
  UnorderedList,
  Link,
} from "@chakra-ui/react";

export const PrinterExploitTool = () => (
  <Box w={'100%'} h={"100vh"} alignItems="center">
    <Container maxW={['100%', '80%']}  p={4}>
      <Text fontSize="3xl"> PRET (Printer exploitation toolkit) </Text>
      <Text fontSize="2xl"> What is PRET? </Text>
      <Text fontSize={'l'}>
        PRET is a command line toolkit used for printer exploitation. <br />
        With this tooling you can easily try to exploit a network or USB printer. <br />
        This can be done due to that printers use a standard language to describe a document that needs to be printed, <br />
        The problem with this is that most of these languages like PS (PostScript) are turing complete. <br />
        This means that you can write fully functional programs with it. PRET utilizes this feature of the printer languages to exploit a printer.
      </Text>
      <br />
      <Text fontSize="2xl"> What can PRET do? </Text>
      <Text fontSize={'l'}>
        When you have installed PRET onto your system you can run it to detect printer devices on your network. <br />
        When you use PRET it will act like a communication layer between a printer and its user. <br />
        PRET can then capture, create and manipulate print jobs and send these to the printer to try and exploit the printer. <br />
        PRET has quite some exploitation options, you can try to run your own code on the system to get a reverse shell, <br />
        but you can also manipulate print jobs or access the file system or read the memory contents of the printer.
      </Text>
      <br />
      <Text fontSize="2xl"> Links: </Text>
      <UnorderedList>
        <ListItem>
          <Link fontSize={'l'} textColor={"blue"} fontWeight={'bold'} href="https://github.com/RUB-NDS/PRET">
            Repo
          </Link>
        </ListItem>
        <ListItem>
          <Link fontSize={'l'} textColor={"blue"} fontWeight={'bold'} href="http://hacking-printers.net/wiki/index.php/Main_Page">
            Printer exploitation wiki (PRET is often used here with examples)
          </Link>
        </ListItem>
      </UnorderedList>
      <br />
      <Text fontSize={'2xl'}>Cases where PRET was used:</Text>
      <UnorderedList>
        <ListItem>
          <Link fontSize={'l'} textColor={"blue"} fontWeight={'bold'} href="#/case/printer">
            HP laserjet printer
          </Link>
        </ListItem>
      </UnorderedList>
    </Container>
  </Box>
)